////////////////////////////////////////////////////
//                                                //
//  ENDPOINT -> /estoque_seguranca/?loja=         //
//                                                //
//  PÁGINA EXCLUSIVA PARA FRANQUEADOS PARA        //
//  DEFINIR O ESTOQUE DE SEGURANÇA DA LOJA.       //
//                                                //
//  RECEBE COMO PARÂMETRO NA URL O ID             //
//  DA LOJA QUE ESTÁ VENDENDO OS PRODUTOS.        //
//                                                //
////////////////////////////////////////////////////  



import React from "react"

import ContinuarComprando from "../components/continuar_comprando";

import api from "../services/api";


function estoqueSeguranca() {

  window.onload = async function() {
    // FUNÇÃO CHAMADA NO CARREGAMENTO DESTA PÁGINA ('/estoque_seguranca/?loja=')

      var params = window.location.search 
      var urlparams = new URLSearchParams(params)
      var loja = urlparams.get('loja')
      
      if(loja != sessionStorage['loja']){  // VERIFICA SE A LOJA DA URL É A MESMA LOJA DA SESSION
        window.location.href = '/estoque_seguranca/?loja='+ sessionStorage['loja']  // CASO NÃO SEJA, REDIRECIONA PARA A PÁGINA DA LOJA DA SESSION
      }
      
      var login = await api.post('verificar_login',{  // VERIFICA NO DB SE A LOJA CORRESPONDE AO TOKEN E TAMBÉM BUSCA O VALOR DO ESTOQUE DE SEGURANÇA DA LOJA
        "id_loja": sessionStorage['loja'],
        "login": sessionStorage['login']
      }).then((response) => {
        return response
      })    
      // login['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
        // 'login' ->  BOOLEANO QUE DEFINE SE O USUÁRIO PODE PERMANECER NA PÁGINA

        // 'id' -> STRING COM O ID DO USUÁRIO CORRETO
          // ISSO OCORRE CASO 'login' SEJA FALSO PORQUE OS TOKENS DE LOGIN SAO INCOMPATÍVEIS
          // CASO 'login' SEJA FALSO E O TERMO 'id' NÃO ESTEJA NO DICIONÁRIO, O USUÁRIO NÃO FOI ENCONTRADO NO DB
      
        // 'estoque_seguranca' -> INT COM O VALOR DO ESTOQUE DE SEGURANÇA QUE ESTÁ SALVO NO DB
          // ESSE VALOR APARECE NO DICIONÁRIO APENAS SE LOGIN FOR TRUE
      
      if(!login['data']['login']){  // SE NÃO CORRESPONDER
        if(login['data']['id']){
          sessionStorage['loja'] = login['data']['id']  // TROCA A LOJA DA SESSION
          window.location.href = '/estoque_seguranca/?loja='+ login['data']['id']  // E REDIRECIONA PARA A PÁGINA DA LOJA CORRETA
        }
        else{
          window.location.href = '/?id='+ sessionStorage['loja']  // E REDIRECIONA PARA A PÁGINA DA LOJA CORRETA
        }
      }

      document.getElementById('estoque_seguranca').value = login['data']['estoque_seguranca']  // DEFINE NO INPUT 'estoque_seguranca' O VALOR DE SEGURANCA REGISTRADO NO DB
    }

  async function teste_submit(){  // FUNÇAÕ PARA ADICIONAR NO DB O NOVO VALOR DO ESTOQUE DE SEGURANÇA
    // FUNÇÃO CHAMADA AO CLICAR NO BOTÃO 'confirmar_estoque_seguranca' DESTA PÁGINA
    
    document.getElementById('estoque_seguranca').classList.remove('border-erro')  // REMOVE ERROS ANTERIORES

    
    if(sessionStorage['login'].includes('/')){  // VERIFICA SE O USUARIO ESTÁ LOGADO COMO FRANQUEADO
        var estoque_seguranca = await api.post('estoque_seguranca',{  // SALVA NO DB O NOVO VALOR DO ESTOQUE DE SEGURANCA
          "estoque": document.getElementById('estoque_seguranca').value,
          "login": sessionStorage['login']
        }).then((response) => {
          return response
        })    
        // NÃO RETORNA NADA 
        
      window.location.href = '/?id='+sessionStorage['loja']  // REDIRECIONA NOVAMENTE PARA A HOME

    }
  }

  function define_zero(){  // FUNÇÃO PARA NÃO PERMITIR VALORES VAZIOS NO INPUT 'estoque_seguranca'
    // FUNÇÃO CHAMADA NA ALTERAÇÃO DO VALOR DO INPUT 'estoque_seguranca' DESTA PÁGINA
    
    if(!document.getElementById('estoque_seguranca').value){  // SE ESTIVER COM O CAMPO VAZIO
      document.getElementById('estoque_seguranca').value = 0  // ALTERA PARA ZERO
    }
  }


  // CONDIÇÕES DE LOGIN
  if(!sessionStorage['login']){  // CASO O USUARIO NAO ESTEJA LOGADO
    window.location.href = '/?id='+ sessionStorage['loja']     
  }  
  else{
    if(!sessionStorage['login'].includes('/')){  // OU ESTEJA LOGADO COMO USUÁRIO E NÃO FRANQUEADO
      window.location.href = '/?id='+ sessionStorage['loja']  // REDIRECIONA PARA A PÁGINA HOME
    }
    else{  // CASO ESTEJA LOGADO COMO FRANQUEADO RENDERIZA A PÁGINA

      // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
        // 'ContinuarComprando' -> VERSÃO DO HEADER QUE NÃO APARECE A BARRA DE PESQUISA E SIM BOTÃO DE VOLTAR PARA A PÁGINA HOME      
      return(
      <div>
            <div>
              <ContinuarComprando />
            </div>

        <div class='custom-container card-checkout px-0 pt-3 mt-10'>

        <div class='px-0 py-0 mx-0 border-bottom'>
          <div class="col-12 py-0 px-3 mx-0 mb-3">
              <h5 class='montserrat verde'>Estoque de Segurança</h5>
              <input onChange={define_zero} min='0' id='estoque_seguranca' type='number' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
          </div>                 
        </div>

        <div class="my-4">
            <div class='col col-12 row px-2 mx-0'>
                <div class="px-0 row col col-12 mx-0">
                    <div id='msg' class='mx-0 px-0 vermelha montserrat col-9'>

                    </div>
                    <div class="col-3 px-0 mx-0">
                      <button class="btn-verde pull-right" id='confirmar_estoque_seguranca' onClick={teste_submit}>
                        <i class="fa fa-check mr-4 montserrat"></i>Confirmar
                      </button>
                    </div>
                </div>
            </div>
        </div>
        </div>
      </div>
      )
    }
  }
}

export default estoqueSeguranca;
